import Swiper, { A11y, Keyboard, Pagination } from 'swiper'

const ArticleSwiper = {
  init() {
    document.querySelectorAll<HTMLElement>('[data-article-swiper]').forEach((element) => {
      const block = element.closest<HTMLElement>('.articles-block')
      const previousButton = block?.querySelector<HTMLButtonElement>('[data-article-swiper-previous]')
      const nextButton = block?.querySelector<HTMLButtonElement>('[data-article-swiper-next]')
      const pagination = block?.querySelector<HTMLElement>('[data-article-swiper-pagination]')

      const updateNavigation = (swiper: Swiper) => {
        if (previousButton) previousButton.disabled = swiper.isBeginning
        if (nextButton) nextButton.disabled = swiper.isEnd
      }

      const swiper = new Swiper(element, {
        modules: [A11y, Keyboard, Pagination],
        a11y: {
          containerMessage: 'Articles',
          slideLabelMessage: '{{index}} of {{slidesLength}}',
        },
        grabCursor: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        resizeObserver: false,
        slidesPerView: 1,
        spaceBetween: 16,
        pagination: pagination
          ? {
              el: pagination,
              clickable: true,
              bulletElement: 'button',
              renderBullet: (index, className) => `<button type="button" class="${className}" aria-label="Go to article ${index + 1}"></button>`,
            }
          : undefined,
        breakpoints: {
          992: {
            slidesPerView: 'auto',
            spaceBetween: 0,
          },
        },
        on: {
          afterInit: updateNavigation,
          slideChange: updateNavigation,
          resize: updateNavigation,
        },
      })

      previousButton?.addEventListener('click', () => swiper.slidePrev())
      nextButton?.addEventListener('click', () => swiper.slideNext())
    })
  },
}

export default ArticleSwiper
